import { render, staticRenderFns } from "./WillCreation.vue?vue&type=template&id=80a1af48"
import script from "./WillCreation.vue?vue&type=script&lang=js"
export * from "./WillCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports